<template>
  <div class="pt-1 pb-3">
    <div class="is-flex">
      <input
        type="checkbox"
        class="mb-auto mt-1 mr-1"
        ref="iptCheckbox"
        v-e2e="e2e ? e2e : id"
        :class="{ 'is-clickable': !disabled }"
        :id="id"
        :value="modelValue"
        :checked="modelValue"
        :disabled="disabled"
        @input="$emit('update:modelValue', $event.target.checked)"
      />

      <div>
        <div class="is-flex">
          <label
            class="mb-0"
            :class="{'is-disabled': disabled}"
            @click="() => $refs.iptCheckbox.click()"
          >
            {{ label }}
          </label>
          <span
            v-if="hasTitulo"
            class="icon tip-icon ml-1"
            :title="tituloTip"
          >
            <i class="fa fa-question-circle is-size-6"></i>
          </span>
        </div>
        <p v-if="microcopia" class="is-size-7">
          <i>{{ microcopia }}</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfCheckbox",
  props: {
    label: String,
    id: String,
    e2e: String,
    modelValue: Boolean,
    disabled: Boolean,
    microcopia: String,
    tituloTip: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    hasTitulo() {
      return this.tituloTip != ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
input:disabled {
  cursor: not-allowed;
}

label.is-disabled {
  color: #7a7a7a;
}

.tip-icon {
  height: 1em;
  display: inline-block;
}
</style>
